import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class ResearchDataApiService {
  readonly BASE_HREF = '/api/v1.0/research-data';
  constructor(private http: HttpClient, private translocoService: TranslocoService) {}

  getDataFromFullUrl(fullPath: string, label = '') {
    /* we need to add /api so interceptor will trigger*/
    const url = new URL(fullPath);
    const apiLink = `/api${url.pathname}${url.search}`;
    let queryParams = new HttpParams();
    queryParams = queryParams.append('label', label.toString());
    queryParams = queryParams.append('language', this.translocoService.getActiveLang());
    return this.http.get(apiLink, { responseType: 'text', params: queryParams });
  }
}
